/*
 * Shared step title/subtitle typography for the elevated onboarding shell,
 * consumed by both the disputes intake modal and the /welcome onboarding pages.
 */
import classNames from "classnames";
import { memo, ReactNode } from "react";
import { Flex } from "../flex";
import * as css from "./redo-elevated-onboarding-step-text.module.css";

export const RedoElevatedOnboardingStepTitle = memo(
  function RedoElevatedOnboardingStepTitle({
    accessory,
    children,
    noWrap = false,
  }: {
    children: ReactNode;
    /** Inline node rendered after the title; switches to a wrapping flex layout. */
    accessory?: ReactNode;
    /** Keep the title on one line (e.g. width-stable text animations). Ignored when `accessory` is set. */
    noWrap?: boolean;
  }) {
    if (accessory) {
      return (
        <Flex
          align="center"
          as="h1"
          className={css.title}
          data-arbiter="RedoElevatedOnboardingStepTitle"
          gap="sm"
          wrap="wrap"
        >
          {children}
          {accessory}
        </Flex>
      );
    }
    return (
      <h1
        className={classNames(css.title, noWrap && css.titleNoWrap)}
        data-arbiter="RedoElevatedOnboardingStepTitle"
      >
        {children}
      </h1>
    );
  },
);

export const RedoElevatedOnboardingStepSubtitle = memo(
  function RedoElevatedOnboardingStepSubtitle({
    children,
  }: {
    children: ReactNode;
  }) {
    return (
      <p
        className={css.subtitle}
        data-arbiter="RedoElevatedOnboardingStepSubtitle"
      >
        {children}
      </p>
    );
  },
);
